export var formatCountSubtitle = function (formatMessage, totalRecords, isCountCapped) {
    return formatMessage({
        id: isCountCapped
            ? "ui-br-legaldeposits.pane.subtitle.countCapped"
            : "ui-br-legaldeposits.pane.subtitle.count",
    }, { count: totalRecords });
};
